import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  promo: null
};

// getters
export const getters = {
  user: state => state.user,
  promo: state => state.promo
};

// mutations
export const mutations = {

  /**
   * Store user data
   * @param state
   * @param user
   */
  [types.STORE_USER](state, user) {
    state.user = user;
  },

  /**
   * Store user data
   * @param state
   * @param promo
   */
  [types.STORE_PROMO](state, promo) {
    state.promo = promo;
  },

  /**
   * GEt User data
   * @param state
   * @returns {null|*}
   */
  [types.GET_USER](state) {
    return state.user
  },
};

// actions
export const actions = {
  storeUser({commit, dispatch}, payload) {
    commit(types.STORE_USER, payload)
  },
  getUser({commit}) {
    commit(types.GET_USER)
  },
  setPromo({commit}, payload) {
    commit(types.STORE_PROMO, payload);
  },
  clearPromo({commit}) {
    commit(types.STORE_PROMO, '');
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js